/* @flow */
import { Container } from 'flux/utils';
import React from 'react';
import PaymentAccountStore from 'payments/stores/PaymentAccountStore';
import IdentityAdditionalVerificationModal from 'payments/components/IdentityAdditionalVerificationModal.jsx';
import PaymentAccountActions from 'payments/actions/PaymentAccountActions';
import PaymentAccount from 'entities/PaymentAccount';

type State = {
  account: PaymentAccount,
};

class IdentityAdditionalVerificationModalContainer extends React.Component {
  state: State;

  static getStores() {
    return [
      PaymentAccountStore,
    ];
  }

  static calculateState(): State {
    return {
      account: PaymentAccountStore.getPaymentAccount(),
    };
  }

  render() {
    return (
      <IdentityAdditionalVerificationModal
        {...this.props}
        account={this.state.account}
        patchPII={PaymentAccountActions.patchPII}
      />
    );
  }
}

export default Container.create(IdentityAdditionalVerificationModalContainer, { withProps: true, pure: false });



// WEBPACK FOOTER //
// ./src/payments/containers/IdentityAdditionalVerificationModalContainer.jsx